import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NbAuthOAuth2JWTToken, NbAuthService } from '@nebular/auth';
import { NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { WiadomoscService } from '../../../@core/http/wiadomosc.service';
import { TokenPayload } from '../../../shared/models/token-payload.model';
import { Wiadomosc } from '../../../shared/models/wiadomosc.model';

@Component({
  selector: 'ngx-wiadomosc',
  templateUrl: './wiadomosc.component.html',
  styleUrls: ['./wiadomosc.component.scss'],
})
export class WiadomoscComponent implements OnInit {

  form: FormGroup;
  token: TokenPayload;

  constructor(
    private formBuilder: FormBuilder,
    private toastrService: NbToastrService,
    private wiadomoscService: WiadomoscService,
    private translate: TranslateService,
    authService: NbAuthService,
  ) {
    this.form = this.formBuilder.group({
      cel: new FormControl('', [Validators.required]),
      temat: new FormControl('', [Validators.required]),
      tresc: new FormControl('', [Validators.required]),
    });
    authService.onTokenChange()
      .subscribe((token: NbAuthOAuth2JWTToken) => {
        if (token.isValid()) {
          this.token = token.getAccessTokenPayload();
        }
      });
  }

  ngOnInit() {
  }

  get f() { return this.form.controls; }

  onSubmit(wiadomosc: Wiadomosc, valid: boolean) {
    this.form.markAllAsTouched();
    if (!valid) {
      return;
    }

    this.wiadomoscService.wyslij(wiadomosc).subscribe(() => {
      this.form.reset();
      this.toastrService.show('', this.translate.instant('komunikat.wiadomosc-wyslana'), { status: 'success' });
    });
  }
}
